/**
 * Lloyds (LBG) CTA sizing.
 *
 * Every CTA is the same height on every screen and both breakpoints — mobile
 * ones are full width, desktop ones hug their label. The height is applied by
 * the theme's `MuiButton` contained/outlined overrides, so it holds even for
 * buttons that pass no sizing of their own; `MOBILE_CTA_HEIGHT` in ./mobile
 * re-exports it for the mobile call sites that size their own rows.
 */
export const CTA_HEIGHT = 48;

/**
 * Desktop CTAs hug their label rather than filling the ~140px min-width the
 * theme's `MuiButton` root sets.
 */
export const DESKTOP_CTA_SX = {
  minWidth: 0,
  minHeight: CTA_HEIGHT,
  padding: "0 28px",
  fontSize: "18px",
  lineHeight: 1.2,
};
